// 组件内检查用户登录机制
// import { Toast } from 'mint-ui'
import { mapGetters } from 'vuex'
// import { TimeLoading } from '@/utils/request'
import { appUser } from '@/utils'

function shareAppMessage(shareData, index) {
  const data = (shareData && shareData()) || {}
  // 循环10s检查
  if (index > 5) return
  // 设置默认分享内容
  if (!data.title) data.title = '友邻少年'
  if (!data.desc) data.desc = '读外刊，学英文，看世界！'
  if (!data.link) data.link = location.href
  if (!data.imgUrl) data.imgUrl = 'https://img-ylsn-test.ylyk.com/server/image/course/2025_01_03_1735897058532.png' // YLYK

  console.log('setShareData', data, index)

  // 不是默认标题，则分享
  if (data.title === '友邻少年' && shareData) {
    const time = index === 0 ? 1000 : 2000
    setTimeout(() => shareAppMessage(shareData, ++index), time)
  }
  window.wx.onMenuShareAppMessage(data)
  window.wx.onMenuShareTimeline(data)
}

export default {
  computed: {
    ...mapGetters('user/login', [
      'getWXUser',
      'user', // 取 appUser 或者 getWXUser
      'jssdkConfig'
    ])
  },
  watch: {
    // 获取到APPID后，设置分享信息
    'jssdkConfig.appId'(appId) {
      if (appId) {
        shareAppMessage(this.setShareData, 0)
      }
    },
    'getWXUser.userId'(userId) {
      // 有用户ID和token的才算正常用户
      // let close = true
      // const loading = TimeLoading('getWXUser.userId', { isOpen: true })

      const canHandleCallback =
        ['#/pullnew', '#/pullnew2023', '#/pullnew/detail', '#/confirm-pay', '#/receive'].findIndex(
          item => item === location.hash
        ) !== -1 // 新用户拉新页面只获取微信的信息 不需要token和userId
      console.log('canHandleCallback', canHandleCallback, appUser, userId, this.getWXUser)
      if ((userId > 0 && (appUser.token || this.getWXUser.userId)) || canHandleCallback) {
        // Toast({ message: '微信授权成功：' + userId })
        // 组件需要加载用户的数据
        const getData = this.getWXUserAfter_getData || this.created_hasToken // 再次初始化
        if (getData) {
          // close = false
          getData({
            done: () => {
              // loading('close')
            }
          })
        }
      } else {
        console.log('跳手机号登陆页面11')
        appUser.isNotUserToLogin({ type: 'button' })
      }
      // if (close) {
      //   loading('close')
      // }
    }
  },
  created() {
    console.log('[created]')
    // 初始化组件数据
    if (this.hasToken()) {
      console.log('[created] created_hasToken')
      const created = this.created_hasToken
      created && created()
    }
  },
  //
  activated() {
    console.log('[activated]')
    // 初始化静态数据（登录跳转过来）
    if (this.hasToken() && this._token == null) {
      console.log('[activated] created_hasToken')
      const created = this.created_hasToken
      created && created()
    }
    // 初始化变化的数据（登录跳转过来）
    if (this.hasToken()) {
      console.log('[activated] activated_hasToken')
      const activated = this.activated_hasToken
      activated && activated()
    }
    // 检查无授权时跳转的页面
    // if (appUser.toView) {
    //    this.$router.replace(appUser.toView)
    // }
  },
  methods: {
    hasToken({ action } = {}) {
      this._token = appUser.token
      let yes = Boolean(appUser.token || '')
      // 检查一次APP登录成功的用户
      if (action && !yes && appUser.isNative) {
        appUser.getNativeUser()
        yes = Boolean(appUser.token || '')
        if (yes) {
          console.log('appUser.token > yes: ', appUser.token)
        }
      }
      return yes
    },
    // 步骤
    $step(options) {
      appUser.showStep(options)
    }
  }
}
